import { Box, useMediaQuery, useTheme } from '@mui/material';
import {
  FeaturesContainer,
  GetInTouchButton,
  Header,
  ImagesContainer,
} from './components';

const DistributionLicense = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('desktop'));

  return (
    <Box
      sx={{
        width: '100%',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(5),
        background:
          'linear-gradient(90deg, rgba(82, 89, 150, 0.3) 0%, rgba(82, 89, 150, 0.7) 100%)',
        [theme.breakpoints.down('sm')]: {
          padding: theme.spacing(3),
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
          },
        }}
      >
        <Box
          sx={{
            [theme.breakpoints.down('sm')]: {
              display: 'flex',
              flexDirection: 'column',
            },
          }}
        >
          <Header />
          <FeaturesContainer />
          <GetInTouchButton />
        </Box>
        {!isMobile && <ImagesContainer />}
      </Box>
    </Box>
  );
};

export default DistributionLicense;
